import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import NavbarCliente from '../NavbarCliente/NavbarCliente';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tienda, setTienda] = useState([]);

    useEffect(() => {
        cargarBanners();
        cargarTienda();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                console.log(data); // Agrega esto para ver la respuesta
                // Verifica que data.banner exista y sea un array
                const bannersSeleccionados = Array.isArray(data.banner) ?
                    data.banner.filter(banner => banner.seleccion === 'Si') : [];
                const bannerImages = bannersSeleccionados.map(banner => banner.imagen);
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false); // Asegúrate de que loading se actualice en caso de error
            });
    };


    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data?.tienda?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1} alt="logo" />
                    ) : (
                        <img src={logo} alt="logo" />
                    )}


                    <div className='deColumnNav'>
                        {tienda?.nombre ? (
                            <h2>{tienda?.nombre}</h2>
                        ) : (
                            <h2>Mi Tienda</h2>
                        )}
                        {tienda?.eslogan ? (
                            <strong>{tienda?.eslogan}</strong>
                        ) : (
                            <strong>Mi Eslogan</strong>
                        )}


                    </div>
                </Anchor>

                <div className='deFLexNavs'>
                    <InputSerach />
                    <Favoritos />
                    <NavbarCliente />
                    <div className={`nav_toggle ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    {/* ✅ FIX: se eliminó el bloque <fondo> con imagen separada.
                        Profile.jsx ya renderiza su propia portada (banner + avatar)
                        desde el borde superior del panel, sin dejar espacio en blanco. */}
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <Profile onClose={() => setIsOpen(false)} />
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
